<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
    <!-- <div id="hide">111111</div> -->
  </div>
</template>
<script>
// import DevicePixelRatio from '../src/request/devicePixelRatio'
export default {
  name: "app",
  data() {
    return {
      isRouterAlive: true,
    };
  },
  provide() {
    //提供
    return {
      reload: this.reload(),
    };
  },
  // created() {
  //   new DevicePixelRatio().init()
  // },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>
<style lang="less">
#app,
body,
html {
  width: 100%;
  height: 100%;
  overflow: auto;
}

/*滚动条样式*/
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  width: 6px;
  background: rgba(#101f1c, 0.1);
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(144, 147, 153, 0.5);
  background-clip: padding-box;
  min-height: 28px;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
  transition: background-color 0.3s;
  cursor: pointer;
}

::-webkit-scrollbar-thumb:hover {
  background-color: rgba(144, 147, 153, 0.3);
}

// #hide{
//   position: fixed;
//   width: 970px;
//   height: 840px;
//   background-color: aqua;
//   top:60px;
//   right: 0;
// }
.el-message-box {
  .el-message-box__header {
    // background: linear-gradient(to right, #eaf1ad, #eaeeca);
    transition: all 0.3s;
    padding: 12px 20px 12px;
  }

  .el-message-box__content {
    margin-top: 10px;
    margin-bottom: 10px;
    // display: flex;
    // align-items: center;
    // justify-content: center;
  }

  .el-message-title {
    color: #606266;
    font-weight: 600;
  }

  .el-icon-close:before {
    font-size: 22px;
    // color: #e6a23c;
    color: #606266;
  }

  // .el-message-box__btns {
  //   // display: flex;
  //   // align-items: center;
  //   // justify-content: space-evenly;
  //   // margin-left: 30px;
  //   .el-button {
  //     color: #000;
  //     background: #e6a23c;

  //     &:hover {
  //       color: #fff;
  //     }
  //   }
  // }
}

.dialogBtn {
  display: flex;
  align-items: center;
  justify-content: end;
  // margin-left: 30px;
}

.operation_button {
  color: #e6a23c !important;
  // background-color: transparent !important;
}

.el-input.is-active .el-input__inner,
.el-input__inner:focus {
  border-color: #e6a23c !important;
  outline: 0;
}
</style>
<style lang="less" scoped>
:deep(.el-dialog) {
  .el-dialog__header {
    // b2d184
    background: linear-gradient(to right, #eaf1ad, #eaeeca);
    transition: all 0.3s;
    padding: 12px 20px 12px;

    .el-dialog__headerbtn {
      top: 12px;
    }

    .el-dialog__title {
      color: #000;
    }
  }

  .el-icon-close:before {
    font-size: 22px;
    color: #000;
  }

  .el-dialog__body {
    padding: 20px 30px 10px;
  }

  .el-dialog__close {
    display: none;
  }

  .el-dialog__footer {
    padding-right: 30px;
  }
}
</style>
